import React, { useState } from 'react';
import { Send, Sparkles, ChevronDown, ChevronUp, Edit, Save } from 'lucide-react';
interface ChatWindowProps {
  title: string;
  placeholder?: string;
  initialMessage?: string;
  initialContent?: string;
  detailLevel?: number;
  icon?: React.ReactNode;
  onComplete?: () => void;
  onMessageChange?: (message: string) => void;
}
export const ChatWindow = ({
  title,
  placeholder,
  initialMessage,
  initialContent,
  detailLevel = 1,
  icon,
  onComplete,
  onMessageChange
}: ChatWindowProps) => {
  const [message, setMessage] = useState(initialContent || initialMessage || '');
  const [isSystemPromptMinimized, setIsSystemPromptMinimized] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [systemPrompt, setSystemPrompt] = useState('You are an AI assistant designed to help identify potential prospects based on the product description. Focus on finding decision-makers and individuals who would directly benefit from the product or service described.');
  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newMessage = e.target.value;
    setMessage(newMessage);
    if (onMessageChange) {
      onMessageChange(newMessage);
    }
  };
  const handleSubmit = () => {
    if (onComplete && message.toLowerCase().trim() === 'next') {
      onComplete();
    }
  };
  const toggleSystemPrompt = () => {
    setIsSystemPromptMinimized(!isSystemPromptMinimized);
  };
  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };
  return <div className="space-y-4" data-id="element-332">
      {/* System Prompt Card */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col" data-id="element-333">
        <div className="p-3 border-b border-gray-200 flex items-center justify-between cursor-pointer" onClick={() => setIsSystemPromptMinimized(!isSystemPromptMinimized)} data-id="element-334">
          <div className="flex items-center gap-2" data-id="element-335">
            <Sparkles className="h-4 w-4 text-blue-500" data-id="element-336" />
            <h3 className="font-medium text-gray-700" data-id="element-337">System Prompt</h3>
            <span className="text-xs px-1.5 py-0.5 bg-gray-100 text-gray-500 rounded-md" data-id="element-338">
              Power User
            </span>
          </div>
        </div>
        {!isSystemPromptMinimized && <div className="p-4" data-id="element-339">
            <textarea value={systemPrompt} onChange={e => setSystemPrompt(e.target.value)} className="w-full h-32 p-3 bg-gray-50 rounded-md text-sm text-gray-700 resize-none focus:ring-2 focus:ring-blue-500 focus:outline-none border border-gray-300" data-id="element-340" />
          </div>}
      </div>
      {/* Original Chat Window */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-[300px] flex flex-col" data-id="element-341">
        <div className="p-3 border-b border-gray-200 flex items-center justify-between" data-id="element-342">
          <div className="flex items-center gap-2" data-id="element-343">
            {icon}
            <h3 className="font-medium text-gray-700" data-id="element-344">{title}</h3>
          </div>
          <div className="flex items-center gap-3" data-id="element-345">
            <button className="px-2 py-1 text-xs bg-purple-50 text-purple-700 hover:bg-purple-100 rounded-md flex items-center gap-1 transition-colors" data-id="element-346">
              <Sparkles className="h-3 w-3" data-id="element-347" />
              Augment with AI
            </button>
            <span className="text-xs text-gray-500" data-id="element-348">
              Question {detailLevel} of 3
            </span>
            <div className="flex items-center gap-1" data-id="element-349">
              {[...Array(3)].map((_, i) => <div key={i} className={`w-2 h-2 rounded-full ${i < detailLevel ? 'bg-purple-500' : 'bg-gray-200'} transition-colors duration-300`} data-id="element-350" />)}
            </div>
          </div>
        </div>
        <div className="flex-1 p-4 overflow-auto" data-id="element-351">
          <textarea value={message} onChange={handleMessageChange} placeholder={placeholder} className="p-3 bg-gray-50 rounded-md text-sm text-gray-700 w-full h-full resize-none focus:ring-2 focus:ring-[#6366f1] focus:outline-none" data-id="element-352" />
          {onComplete && <p className="text-gray-600 mt-2 text-xs" data-id="element-353">
              Type "next" when you're ready to continue
            </p>}
        </div>
      </div>
    </div>;
};